import Form from "./form";

function App() {
  return (
    <div className="Apsp">
      <Form />
    </div>
  );
}

export default App;
